import { Icon } from '@mui/material';

import './Button.scss';

const Button = ({
	children,
	className,
	disabled,
	type,
	onClick,
	startIcon,
	endIcon
}) => {
	const buttonClass = `button ${className || ''}`;

	return (
		<button
			className={buttonClass}
			type={type || 'button'}
			onClick={onClick}
			disabled={!!disabled}
		>
			{startIcon && <Icon>{startIcon}</Icon>}
			{children}
			{endIcon && <Icon>{endIcon}</Icon>}
		</button>
	);
};

export default Button;
